import { useState } from "react";
import { deleteQuestion } from "../../api/Question";
import QuestionCard from "../cards/questionCard";

const QuestionTable = ({
  data,
  handleRefresh,
  setShowNotification,
  setStatus,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  setRefresh,
  setEdit,
  setQuestionId,
}) => {
  const [showDeleteAcception, setShowDeleteAcception] = useState(false);
  const [deleteQuestionId, setDeleteQuestionId] = useState(null);

  const deleteQ = async () => {
    try {
      const res = await deleteQuestion(deleteQuestionId);
      setRefresh((refresh) => !refresh);
      setShowNotification(true);
      setStatus(res.status);
      setShowDeleteAcception(false);
    } catch (err) {
      setShowNotification(true);
      setStatus(502);
      setShowDeleteAcception(false);
    }
  };

  if (!data || data.length === 0) {
    return (
      <div className="w-full mx-auto bg-white rounded-lg shadow-lg p-8 mt-1 text-center">
        <p className="text-gray-500">هیچ سوالی یافت نشد</p>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto bg-gray-50 rounded-lg p-4 sm:p-6 mt-1">
      {/* تاییدیه حذف (بدون تغییر) */}
      {showDeleteAcception && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="w-full max-w-md bg-white shadow-2xl rounded-xl p-6">
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold text-red-600 mb-2">هشدار</h2>
              <p className="text-gray-700 text-sm">
                آیا از حذف این سوال اطمینان دارید؟
              </p>
            </div>
            <div className="flex justify-between gap-2">
              <button
                className="bg-red-500 hover:bg-red-700 transition text-white px-4 py-2 rounded-lg w-full"
                onClick={deleteQ}
              >
                تایید
              </button>
              <button
                className="bg-gray-300 hover:bg-gray-400 transition text-gray-800 px-4 py-2 rounded-lg w-full"
                onClick={() => {
                  setShowDeleteAcception(false);
                  setDeleteQuestionId(null);
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* شبکه کارت‌ها با عرض A4 */}
      <div className="grid grid-cols-1 gap-6 justify-items-center">
        {data.map((item, index) => {
          const rowNumber = (currentPage - 1) * 10 + index + 1;
          return (
            <QuestionCard
              key={item._id || index}
              item={item}
              index={index}
              rowNumber={rowNumber}
              setShowDeleteAcception={setShowDeleteAcception}
              setDeleteQuestionId={setDeleteQuestionId}
              handleRefres={handleRefresh}
              setEdit={setEdit}
              setQuestionId={setQuestionId}
              allQuestions={data}
            />
          );
        })}
      </div>

      {/* صفحه‌بندی (بدون تغییر) */}
      {totalPages > 1 && onPageChange && (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-8">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-lg border border-gray-300 transition-all 
              ${
                currentPage === 1
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-[#075B4A] hover:text-white"
              }`}
          >
            قبلی
          </button>
          <div className="flex flex-wrap justify-center items-center gap-2">
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .slice(
                Math.max(0, currentPage - 3),
                Math.min(totalPages, currentPage + 2),
              )
              .map((num) => (
                <button
                  key={num}
                  onClick={() => onPageChange(num)}
                  className={`px-3 py-1.5 rounded-lg border transition-all
                    ${
                      num === currentPage
                        ? "bg-[#075B4A] text-white"
                        : "bg-white hover:bg-gray-100"
                    }`}
                >
                  {num}
                </button>
              ))}
          </div>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-lg border border-gray-300 transition-all 
              ${
                currentPage === totalPages
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-[#075B4A] hover:text-white"
              }`}
          >
            بعدی
          </button>
        </div>
      )}
    </div>
  );
};

export default QuestionTable;
